export default __webpack_public_path__ + "static/media/4879.c5454ce4.png";